/* istanbul ignore file */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SpinnerStateT = {
    isLoading: boolean;
    description: string,
}

export const initialState: SpinnerStateT = {
    isLoading: false,
    description: '',
};

export const spinnerSlice = createSlice({
    name: 'spinner',
    initialState,
    reducers: {
        loadSpinner: (state, action: PayloadAction<string>) => {
            state.isLoading = true;
            state.description = action.payload;
        },
        unloadSpinner: (state) => {
            state.isLoading = false;
            state.description = '';
        },
    },
});

export const {
    loadSpinner,
    unloadSpinner,
} = spinnerSlice.actions;

export default spinnerSlice.reducer;
